export default {
  meetingsMetadata: {
    roles: {
      participant: 'Мои встречи',
      supervisor: 'Я запланировал',
    },
    statuses: {
      planned: 'Запланирована',
      done: 'Проведена',
      overdue: 'Просрочена',
      cancelled: 'Отменена',
      new: 'Новая',
      inProgress: 'В работе',
      ready: 'Готово',
    },
    formats: {
      online: 'Онлайн',
      offline: 'Оффлайн',
    },
    statusesDescriptions: {
      planned: 'Встреча запланирована, вы можете перенести встречу на другое время и дату',
      done: 'Встреча завершена, вы можете указать итоги, а также добавить задачи себе и сотруднику',
      overdue: 'Срок встречи истёк, вы можете перенести встречу на другое время и дату',
      cancelled: 'Встреча отменена',
    },
    buttons: {
      addAnotherQuestion: 'Добавить ещё вопрос',
      goToMeeting: 'Перейти во встречу',
      viewTasks: 'Посмотреть задачи',
      doneMeeting: 'Завершить встречу',
      cancelMeeting: 'Отменить встречу',
      addTask: 'Добавить задачу',
      removeTask: 'Удалить задачу',
      doneTasks: 'Завершить и поставить задачи',
      cancel: 'Отмена',
      confirmDone: 'Да, завершить',
      confirmContinue: 'Да, продолжить',
      confirmAdd: 'Да, добавить',
      confirmRemove: 'Да, убрать',
    },
    agenda: 'Повестка',
    myTasks: 'Мои задачи',
    tasksForEmployee: 'Задачи для сотрудника',
    tasksForSupervisor: 'Задачи руководителя',
    meetingRoom: 'Переговорная',
    resultsMeeting: 'Итоги встречи',
    listOfQuestions: 'Список вопросов',
    createMeeting: 'Запланировать встречу',
    role: 'Роль',
    formLabels: {
      type: 'Тип встречи',
      supervisor: 'Руководитель встречи',
      employee: 'Сотрудник',
      date: 'Дата',
      time: 'Время',
      format: 'Формат',
      link: 'Ссылка',
      agenda: 'Повестка',
      summary: 'Итоги встречи',
      summarySupervisor: 'Итоги встречи руководителя',
      theme: 'Тематика',
      question: 'Вопрос',
      name: 'Название задачи',
      deadline: 'Дедлайн',
      importance: 'Важность',
    },
    confirmDoneMeeting: {
      title: 'Вы уверены, что хотите завершить встречу?',
      text: 'После завершения встречи, её нельзя будет перенести. Вы можете указать итоги встречи сейчас или позже.',
    },
    cancelMeeting: 'Отменить встречу?',
    successMessages: {
      createMeeting: 'Встреча успешно создана',
      changeMeeting: 'Встреча успешно изменена',
      addQuestions: 'Вопросы успешно добавлены',
      rescheduleMeeting: 'Встреча успешно перенесена',
      doneMeeting: 'Статус встречи успешно изменён',
      cancelMeeting: 'Встреча успешно отменена',
      deleteTask: 'Задача успешно удалена',
      changeShowTask: 'Видимость задачи на доске успешно изменена',
      createTask: 'Задача успешно создана',
    },
    errorMessages: {
      createMeeting: 'Не удалось создать встречу',
      changeMeeting: 'Не удалось изменить встречу',
      addQuestions: 'Не удалось добавить вопросы',
      rescheduleMeeting: 'Не удалось перенести встречу',
      doneMeeting: 'Не удалось изменить статус встречи',
      cancelMeeting: 'Не удалось отменить встречу',
      deleteTask: 'Не удалось удалить задачу',
      changeShowTask: 'Не удалось изменить видимость задачи на доске',
      createTask: 'Не удалось создать задачу',
    },
    tableHeaders: {
      name: 'Наименование',
      theme: 'Тематика',
      employee: 'Сотрудник',
      position: 'Должность',
      team: 'Команда',
    },
    deleteQuestion: 'Удалить вопрос?',
    noQuestions: 'Вы пока не добавили ни одного вопроса',
    confirmDeleteTask: {
      title: 'Удалить задачу?',
      text: 'Задача будет удалена из встречи и с доски',
    },
    changeShowTask: {
      show: 'Добавить задачу на доску?',
      notShow: 'Убрать задачу с доски?',
    },
    noTasks: 'Нет задач',
    tooltips: {
      addTask: 'Добавить задачу на доску',
      removeTask: 'Убрать задачу с доски',
      deleteTask: 'Удалить задачу',
      participant: 'Я сотрудник',
      supervisor: 'Я руководитель',
    },
    addQuestionsTitle: 'Добавить вопросы',
    tabs: {
      basic: 'Базовые вопросы',
      new: 'Новый вопрос',
    },
    title: 'Комментарий',
    question: 'Вопрос',
    labels: 'Комментарии',
    dialogTitle: 'Новая задача',
    placeholders: {
      selectStatus: 'Выберите статус',
      selectRole: 'Выберите роль',
    },
    noMeetings: 'Пока не запланировано ни одной встречи',
    roleParticipant: 'Сотрудник',
    roleSupervisor: 'Руководитель',
    linkOnMeeting: 'Ссылка на встречу',
  },
};
